import { saveState } from '@chama/utils/functions/local-storage';
import Raven from '@app/sentry';
import { startFetchingTickets } from './orders';

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT = 'LOGOUT';
export const GET_USER_KIND = 'GET_USER_KIND';
export const SET_CS_ADMIN_ACCOUNTS = 'SET_CS_ADMIN_ACCOUNTS';
export const UNSET_ACCOUNT = 'UNSET_ACCOUNT';

const loginSuccess = (account, username, password) => ({
  type: LOGIN_SUCCESS,
  account,
  username,
  password,
});

const getUserKind = (dispatch, api) => {
  return api.getUserKind().then(({ kind }) => {
    dispatch({
      type: GET_USER_KIND,
      kind,
    });
  });
};

const loginApi = (account, username, password) => (dispatch, getState, { api }) => {
  api.signIn(account, username, password);

  return dispatch(startFetchingTickets()).then(() => {
    return getUserKind(dispatch, api).then(() => {
      dispatch(loginSuccess(account, username, password));
    });
  });
};

const loginFirebaseAndOrApi = (account, username, password) => (
  dispatch,
  getState,
  { firebaseClient },
) => {
  if (getState().featureToggles.firebaseAuthEnabled) {
    const email = `${username}@${account}.dealer.revendedorchama.com`;
    return firebaseClient.signIn(email, password).then(({ user }) => {
      if (getState().featureToggles.toggleApiJwt) {
        return user.getIdToken();
      }

      return dispatch(loginApi(account, username, password)).catch(e => {
        firebaseClient.signOut();
        throw e;
      });
    });
  }

  return dispatch(loginApi(account, username, password));
};

export const login = (account, username, password) => dispatch =>
  dispatch(loginFirebaseAndOrApi(account, username, password)).then(() => {
    Raven.setUserContext({
      id: `${username}@${account}`,
      account,
      username,
    });
  });

const logoutWithoutFirebase = () => (dispatch, getState, { api }) => {
  api.signOut();
  dispatch({ type: LOGOUT });

  saveState(getState());
  // NOTE: IE tax: IE10 will not have flushed localStorage yet if the
  // following is not wrapped in setImmediate :(
  setImmediate(() => {
    window.location = '/login';
  });
};

export const logout = () => (dispatch, getState, { firebaseClient }) => {
  if (getState().featureToggles.firebaseAuthEnabled) {
    firebaseClient.signOut().then(() => {
      dispatch(logoutWithoutFirebase());
    });
  } else {
    dispatch(logoutWithoutFirebase());
  }
};

export const setCustomerServiceAdminAccounts = (customerServiceAdminAccounts = {}) => ({
  type: SET_CS_ADMIN_ACCOUNTS,
  customerServiceAdminAccounts,
});

export const unsetAccount = () => ({
  type: UNSET_ACCOUNT,
});



// WEBPACK FOOTER //
// ./src/actions/user.js